import React from "react";
import PlatformOnlyNotice from "@/component/commom/platform-only-notice";
import competitionIcon from "@public/img/competition.png";

export default function CompetitionPage() {
  return (
    <PlatformOnlyNotice
      title="مسابقات"
      icon={competitionIcon}
      iconAlt="مسابقات"
    />
  );
}
